export const useCopyToClipboard = () => {
  const copy = (content) => {
    if (navigator.clipboard){
      copyToClipboardUsingNavigator(content)
    } else {
      copyToClipboardFallback(content)
    }
  }
  return [copy]
}

const copyToClipboardUsingNavigator = async (content) => {
  try {
    await navigator.clipboard.writeText(content)
  } catch(err) {
    Sentry.captureMessage('Error copying to clipboard')
    Sentry.captureException(err)
  }
}

const copyToClipboardFallback = (content) => {
  const dummy = document.createElement("input")
  document.body.appendChild(dummy)
  dummy.value = content
  dummy.select()
  document.execCommand("copy")
  document.body.removeChild(dummy)
}
